import { render, staticRenderFns } from "./editProDetail.vue?vue&type=template&id=66ba72be&scoped=true&"
import script from "./editProDetail.vue?vue&type=script&lang=js&"
export * from "./editProDetail.vue?vue&type=script&lang=js&"
import style0 from "./editProDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editProDetail.vue?vue&type=style&index=1&id=66ba72be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba72be",
  null
  
)

export default component.exports